import { toast } from "react-toastify";

export const showToastMessage = (message: string, type:string = "success", position: string = "TOP_RIGHT", hideProgressBar: boolean = false) => {
  toast[type](message, {
    position: toast.POSITION[`${position}`],
    className: "foo-bar",
    theme: "colored",
    hideProgressBar,
  });
}